/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LineItemDescriptionQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("LineItemDescriptionQueryOperator");
    }

    getFixupPrototypeFunction() { return LineItemDescriptionQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<LineItemDescriptionQueryOperator>): LineItemDescriptionQueryOperator {
        let obj = Object.assign(new LineItemDescriptionQueryOperator(), model);
        LineItemDescriptionQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LineItemDescriptionQueryOperator>): LineItemDescriptionQueryOperator {
        if (!model) return null;
        return LineItemDescriptionQueryOperator.newInstance(<LineItemDescriptionQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LineItemDescriptionQueryOperator) {
        if (!obj) return;

        models.LineItemDescriptionQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LineItemDescriptionQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LineItemDescriptionQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Line item descriptions by exact description match
     */
    line_item_descriptions: Array<string>;

}
